/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import * as API from "../../http/api";
import * as CustomWidgets from "../customwidgets";
import { TextField, MenuItem, RadioGroup, Radio, FormControlLabel, IconButton } from "@mui/material";
import { theme, customStyles2 } from "../../util/TableStyles"
import { ThemeProvider } from "@mui/material/styles";
import DataTable from "react-data-table-component";
import { noDataComponent } from "../../util/DataObject"
import { Edit } from '@mui/icons-material';
import { useDialog } from "@albo-ui/core";
import GeneralConfirmDialog from "../modals/confirm/GeneralConfirmDialog";

const SpaceTable = (props) => {
  const [data, setData] = useState([]);
  const [roles, setRoles] = useState([]);  
  const history = useHistory();
  const dialogProps = useDialog();
  const [dialogText, setDialogText] = useState({});
  const [item, setItem] = useState(null);
  const [element, setElement] = useState(null);

  useEffect(() => {
    for (let i = 0; i < props.data.length; i++) {
      props.data[i]["checked"] = false;
      props.data[i]["showInfo"] = false;
    }
    if (localStorage.config) {
      let rol = localStorage.config && JSON.parse(localStorage.config)['idRol'] ? [JSON.parse(localStorage.config)['idRol']] : [];
      setRoles(rol);
    }
    setData(JSON.parse(JSON.stringify(props.data.data.content)));
  }, [props.data, props.data.data.content]);

  const changeCheck = (item, index) => {
    for (let i = 0; i < data.length; i++) {
      if (data[i].uuid === item.uuid && index !== i) {
        index = i;
      }
    }

    let d = data;
    for (let i = 0; i < d.length; i++) {
      if (i != index) {
        if (d[i]["checked"]) {
          d[i]["checked"] = !d[i]["checked"];
        }
      }
    }

    d[index]["checked"] = !d[index]["checked"];
    setData(JSON.parse(JSON.stringify(d)));
    if (d[index]["checked"]) {
      props.changeRadio(d[index]);
    } else {
      props.changeRadio({});
    }
  };

  const levelUpgrade = async (uuid, key) => {
    props.changeLoader(true);
    let data = {
      entity: {
        uuid: uuid,
        type: "space_account"
      },
      new_space_level : {
        profile : key.target.value,
        type : "1"
      }
    };

    let request = await API.service('spaceLevelUpgrade', data, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status == 200 && request.data.data.response == 'OK') {
      await props.changeReload()
      props.changeAlert(true, 'success', 'Nivel de cuenta actualizado con éxito');
    }
    props.changeLoader(false);
  }

  const onHandleUpdate = async (name) => {
    props.changeLoader(true);
    onCloseDialogConfirm();

    let data = {
      space: {
        uuid: item.uuid,
        owner: item.owner,
        general: name
      }
    };

    let request = await API.service('spaceUpdate', data, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status == 200 && request.data.data.response == 'OK') {
      await props.changeReload()
      props.changeAlert(true, 'success', 'Nombre de cuenta actualizado con éxito');
    }
    props.changeLoader(false);
  }

  const onOpenUpdate = async (row) => {
    setItem(JSON.parse(JSON.stringify(row)));

    setElement([{
      type: "textField",
      label: "Nombre",
      key: "name",
      text: "A continuación indica el nombre de la cuenta para continuar.",
    }]);
    setDialogText({
      title: "Editar nombre de la cuenta",
      message: "¿Estás seguro que deseas cambiar el nombre actual?.",
      cancelButton: "No, cancelar",
      confirmButton: "Sí, editar",
    });

    dialogProps.openDialog();
  }

  const onCloseDialogConfirm = () => {
    dialogProps.onClose();
    setElement(null);
    setDialogText({});
    setItem(null);
  };

  const hasAction = (action) => {
    return props.config?.actions?.indexOf(action) > -1;
  };

  //   ------------------------------------------------------------------
  const columns = []
  columns.push(
    { selector: (row) => row.accountNumber, name: "Número de cuenta", sortable: true },
    { selector: (row) => row.name, name: "Nombre", sortable: true },
    { selector: (row) => row.typeString, name: "Tipo de cuenta", sortable: true, width: "14%" },
    { selector: (row) => row.status, name: "Estatus", sortable: true, width: "12%" },
    { selector: (row) => row.numCards, name: "Tarjetas", sortable: true, width: "12%" },
  )

  if(props.catalog.length > 0){
    columns.push(
      { cell: (item) => {
        if(item.type !== "5"){
          return (
            <TextField
              select={item.status !== "Inactivo" && item.status !== "Fracasado" ? true : false}
              disabled={item.status == "Inactivo" || item.status == "Fracasado"  ? true : false}
              onChange={levelUpgrade.bind(this, item.uuid)}
              size="small"
              fullWidth
              label={item.subproduct_uuid}
            >           
              {item.status !== "Inactivo" && item.status !== "Fracasado" && props.catalog.map((i) => {
                return (<MenuItem key={i.k} value={i.k}>{i.k}</MenuItem>);
              })}
            </TextField>
          )
        } else {
          return item.level
        }
        }, sortable: true, name: "Nivel de Cuenta", width: "18%"
      }
    )
  }

  columns.push(
    {cell: (item, index) => {
      if(item.checked === undefined){
        item.checked = false 
      }
      return (
        <>
        <RadioGroup aria-label="position" row  value={item.uuid} onChange={changeCheck.bind(this, item, index)}>
          <FormControlLabel control={<Radio value={item.uuid} />} checked={item.checked} label="" />
        </RadioGroup>
        { hasAction("spaceUpdate") && <IconButton title="Editar nombre" onClick={() => onOpenUpdate(item)} color="primary" disabled={item.status !== "Activo"}>
          <Edit />
        </IconButton>}
        </>
      );
      }, name: "Acciones", sortable: true, width: "12%"
    }
  )

  const selectInfo = (item) => {
    if (props.config.fields.in.indexOf("*") == -1) {
      if (props.config.fields.in.indexOf("cdate") == -1) {
        delete item.cdate;
      }
    }
    let isVip = props["data"]["data"]["vip"] ? props?.["config"]?.fields?.in?.indexOf("vip") > -1 ?  true : false : true
    return (
      <div className="select_info">
        <CustomWidgets.SpaceInfo
          data={{
            space: item.data,
            openpayPrefix: props.openpayPrefix,
            rol: roles,
            validateVip: isVip
          }}
          fields={props.config.fields}
        />
      </div>
    );
  };

  return (
    <div style={{ width: "96%", margin: "auto", marginBottom: "30px" }}>
      <ThemeProvider theme={theme}>
        <DataTable
          columns={columns}
          data={data}
          expandableRows={true}
          expandOnRowClicked={false}
          expandableRowsComponent={selectInfo}
          customStyles={customStyles2}
          noDataComponent={noDataComponent}
        />
      </ThemeProvider>

      <GeneralConfirmDialog 
          open={dialogProps.open}
          text={dialogText}
          onClose={onCloseDialogConfirm} 
          onConfirm={onHandleUpdate.bind(this)} 
          item={item}
          element={element}
      />
    </div>
  );
};

export default SpaceTable;
